import React from "react";
import { useFormContext } from "react-hook-form";

import { Connection } from "src/api/connectApi/types";
import { FieldErrors } from "src/api/types";
import { Divider } from "src/base-components/Divider";
import { DataRetentionConfig } from "src/baseConnectionNode/DataRetentionConfig";
import { EnvironmentDataSourceConfig } from "src/baseConnectionNode/EnvironmentDataSourceConfig";
import { InboundWebhookURLField } from "src/connections/config/inboundWebhook/InboundWebhookURLField";
import { Callout } from "src/design-system/Callout";
import { WebhookTimeoutInput } from "src/inboundWebhookNode/WebhookTimeoutInput";
import { InboundWebhookConnectionForm } from "src/inboundWebhookNode/types";

type ConfigPaneProps = {
  connection: Connection;
  immutable: boolean;
  runFieldErrors: FieldErrors | undefined;
};

export const ConfigPane: React.FC<ConfigPaneProps> = ({
  connection,
  immutable,
  runFieldErrors,
}) => {
  const productionWebhookURL = connection.configuration.webhook_url || "";
  const sandboxWebhookURL =
    connection.non_prod_env_configs?.["sandbox"]?.webhook_url || "";

  const formProps = useFormContext<InboundWebhookConnectionForm>();

  return (
    <>
      <EnvironmentDataSourceConfig
        connection={connection}
        disabled={immutable}
        type="webhook"
      />
      <Divider spacing="my-4" />
      <DataRetentionConfig connection={connection} immutable={immutable} />

      {formProps.watch("config.caching.active") && (
        <div className="mb-4 mt-2">
          <Callout type="warning">
            Please ensure that caching is also enabled on any Custom Connection
            node this Webhook might depend on
          </Callout>
        </div>
      )}

      <WebhookTimeoutInput
        immutable={immutable}
        runFieldErrors={runFieldErrors}
      />

      <Divider spacing="my-4" />
      <InboundWebhookURLField
        productionWebhookURL={productionWebhookURL}
        sandboxWebhookURL={sandboxWebhookURL}
      />
    </>
  );
};
